import { UserDetailsComponent } from "./user-details/user-details.component";
import { UserFilterComponent } from "./user-search-bar/filter/filter.component";
import { UserSearchBarComponent } from "./user-search-bar/user-search-bar.component";

export {
  UserDetailsComponent,
  UserSearchBarComponent,
  UserFilterComponent,
};

export const userComponents = [
  UserDetailsComponent,
  UserSearchBarComponent,
  UserFilterComponent,
]